var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
// Loads a script dynamically, with a loading status https://usehooks.com/useScript/
import { useState, useEffect } from 'react';
var cachedScripts = [];
export var useScript = function (src) {
  // Keeping track of script loaded and error state
  var _a = __read(useState({
      loaded: false,
      error: false
    }), 2),
    state = _a[0],
    setState = _a[1];
  useEffect(function () {
    // If cachedScripts array already includes src that means another instance ...
    // ... of this hook already loaded this script, so no need to load again.
    if (cachedScripts.includes(src)) {
      setState({
        loaded: true,
        error: false
      });
    } else {
      cachedScripts.push(src);
      // Create script
      var script_1 = document.createElement('script');
      script_1.src = src;
      script_1.async = true;
      // Script event listener callbacks for load and error
      var onScriptLoad_1 = function () {
        setState({
          loaded: true,
          error: false
        });
      };
      var onScriptError_1 = function () {
        // Remove from cachedScripts we can try loading again
        var index = cachedScripts.indexOf(src);
        if (index >= 0) cachedScripts.splice(index, 1);
        script_1.remove();
        setState({
          loaded: true,
          error: true
        });
      };
      script_1.addEventListener('load', onScriptLoad_1);
      script_1.addEventListener('error', onScriptError_1);
      // Add script to document body
      document.body.appendChild(script_1);
      // Remove event listeners on cleanup
      return function () {
        script_1.removeEventListener('load', onScriptLoad_1);
        script_1.removeEventListener('error', onScriptError_1);
      };
    }
  }, [src] // Only re-run effect if script src changes
  );
  return [state.loaded, state.error];
};